import moment, { Moment } from 'moment';

export const formatApiDate = (value: string | Moment): string => {
    return moment(value).format(process.env.NEXT_PUBLIC_API_DATE_FORMAT);
};
